import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const ConfirmContact = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ConfirmContact/pages/ScheduledConfirmContact'
    ),
)

const ConfirmContactRoutes = [
  <RequireAuthentication
    path="/atendimento-agendado/confirmar-dados"
    key="/atendimento-agendado/confirmar-dados"
    exact
    component={ConfirmContact}
  />,
]

export default ConfirmContactRoutes
